const hoverPop = (function () {
    let pop_wraper
    return (el, binding)=>{
        el.addEventListener('mouseenter',()=>{

            if (!pop_wraper) {
                pop_wraper = document.createElement('div')
                pop_wraper.className = 'table_pop'
                pop_wraper.style.fontSize = binding.arg + 'px' || '12px'
                pop_wraper.addEventListener('click',e => {
                    e.stopPropagation()
                })
                pop_wraper.addEventListener('mouseleave',e => {
                    let pos = el.getBoundingClientRect()
                    if (e.pageX >= pos.left && e.pageX <= pos.right && e.pageY + 10 >= pos.top && e.pageY <= pos.bottom) return
                    else {
                        document.body.removeChild(pop_wraper)
                    }
                })
            }
            pop_wraper.innerHTML = binding.value
            document.body.appendChild(pop_wraper)
            let binder = el.getBoundingClientRect()
            ,screen_height = document.documentElement.clientHeight
            ,screen_width = document.documentElement.clientWidth

            setPos()
            function setPos () {
                if (binder.top + binder.height + pop_wraper.offsetHeight > screen_height) {
                    pop_wraper.style.bottom = binder.bottom + binder.height + 10
                    pop_wraper.classList.remove('up_arrow')
                    pop_wraper.classList.add('down_arrow')
                } else {
                    pop_wraper.style.top = binder.top + binder.height + 10 + 'px'
                    pop_wraper.classList.remove('down_arrow')
                    pop_wraper.classList.add('up_arrow')
                }
                pop_wraper.style.right = (screen_width - binder.right) + 10 + 'px'
            }

        })
        el.addEventListener('mouseleave',e=>{
            if (pop_wraper){
                let pos = pop_wraper.getBoundingClientRect()
                if (e.pageX >= pos.left && e.pageX <= pos.right && e.pageY + 10 >= pos.top && e.pageY <= pos.bottom) return
                else {
                    pop_wraper.remove()
                }
            }
        })
    }
}) ()
export default function install(Vue) {
    
    Vue.directive('content', {
        inserted: hoverPop,
        componentUpdated: hoverPop,
        unbind: function (el) {
            
        }
    });
}